// extracted by mini-css-extract-plugin
export default {"departmentDetail":"index_departmentDetail__eWIBL"};